import NewsletterSection from '@/components/NewsletterSection'

const posts = [
  { id: '1', title: 'Lorem ipsum dolor sit amet consectetur diam', date: '21-08-2024', image: 'https://images.unsplash.com/photo-1466692476868-aef1dfb1e735?w=600&h=500&fit=crop', tags: ['Investment', 'Fundraising'], desc: 'Lorem ipsum dolor sit amet consectetur Diam bibendum ut diam tempus sociis lectus luctus in? Lorem ipsum dolor sit amet consectetur Diam bibendum ut diam tempus sociis lectus luctus in...', size: 'large' },
  { id: '2', title: 'Lorem ipsum dolor', date: '21-08-2024', image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=400&h=220&fit=crop', tags: [], desc: '', size: 'small-top' },
  { id: '3', title: 'Lorem ipsum dolor', date: '21-08-2024', image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400&h=220&fit=crop', tags: [], desc: '', size: 'small-bottom' },
  { id: '4', title: 'Lorem ipsum dolor', date: '21-08-2024', image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=300&h=200&fit=crop', tags: [], desc: '', size: 'sm' },
  { id: '5', title: 'Lorem ipsum dolor sit amet consectetur diam', date: '21-08-2024', image: 'https://images.unsplash.com/photo-1466692476868-aef1dfb1e735?w=600&h=500&fit=crop', tags: ['Fundraising', 'Investment'], desc: 'Lorem ipsum dolor sit amet consectetur Diam bibendum ut diam tempus sociis lectus luctus in? Lorem ipsum dolor sit amet consectetur Diam bibendum ut diam tempus sociis lectus luctus in...tempus sociis lectus luctus in? Lorem ipsum dolor sit amet consectetur Diam bibendum ut diam tempus sociis lectus luctus in...', size: 'large-text' },
  { id: '6', title: 'Lorem ipsum dolor', date: '21-08-2024', image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=300&h=200&fit=crop', tags: [], desc: '', size: 'sm' },
  { id: '7', title: 'Lorem ipsum dolor sit amet consectetur diam', date: '21-08-2024', image: 'https://images.unsplash.com/photo-1579621970795-87facc2f976d?w=800&h=400&fit=crop', tags: ['Investment', 'Fundraising'], desc: '', size: 'wide' },
]

const ArrowBtn = () => (
  <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: '#f97316', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, cursor: 'pointer' }}>
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12,5 19,12 12,19"/></svg>
  </div>
)

const Tag = ({ label }: { label: string }) => (
  <span style={{ fontSize: '10px', fontWeight: 600, color: '#fff', background: 'rgba(30,50,120,0.85)', border: '1px solid rgba(80,100,200,0.5)', borderRadius: '3px', padding: '2px 8px' }}>{label}</span>
)

export default function BlogPage() {
  return (
    <>
      {/* ━━━ HERO ━━━
          Dark collage bg — newspapers + polaroid photos + "Ch" watermark
          "OUR BLOG" centered bold white
          Orange chat bubble bottom-right */}
      <section className="relative overflow-hidden" style={{ height: '340px', background: '#07090e' }}>
        {/* Left polaroid photo */}
        <div style={{ position: 'absolute', left: '-20px', top: 0, bottom: 0, width: '45%', zIndex: 1 }}>
          <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=500&h=400&fit=crop" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.55 }} />
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(90deg, rgba(7,9,14,0.8) 0%, transparent 60%, rgba(7,9,14,0.4) 100%)' }} />
        </div>

        {/* Right photo */}
        <div style={{ position: 'absolute', right: 0, top: 0, bottom: 0, width: '45%', zIndex: 1 }}>
          <img src="https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=500&h=400&fit=crop" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.5 }} />
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(270deg, rgba(7,9,14,0.8) 0%, transparent 60%, rgba(7,9,14,0.4) 100%)' }} />
        </div>

        {/* "Ch" watermark */}
        <div style={{ position: 'absolute', left: '18px', bottom: '-10px', zIndex: 2, fontSize: '220px', fontWeight: 900, color: 'transparent', WebkitTextStroke: '1.5px rgba(255,255,255,0.08)', lineHeight: 1, pointerEvents: 'none', userSelect: 'none' }}>Ch</div>

        {/* "R" right watermark */}
        <div style={{ position: 'absolute', right: '24px', top: '20px', zIndex: 2, fontSize: '160px', fontWeight: 900, color: 'transparent', WebkitTextStroke: '1.5px rgba(255,255,255,0.07)', lineHeight: 1, pointerEvents: 'none', userSelect: 'none' }}>R</div>

        {/* Newspaper-like text overlay strips */}
        <div style={{ position: 'absolute', inset: 0, zIndex: 1, overflow: 'hidden', opacity: 0.06 }}>
          {['THE SEC', 'Market Ann', 'KANG'].map((t, i) => (
            <div key={i} style={{ position: 'absolute', color: 'white', fontWeight: 900, fontSize: i === 0 ? '80px' : '28px', top: i === 0 ? '10px' : i === 1 ? '220px' : '240px', left: i === 0 ? '60px' : i === 1 ? '50%' : '70%', whiteSpace: 'nowrap' }}>{t}</div>
          ))}
        </div>

        {/* Center title */}
        <div style={{ position: 'absolute', inset: 0, zIndex: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <h1 style={{ fontSize: '42px', fontWeight: 900, color: '#fff', letterSpacing: '0.12em', textTransform: 'uppercase' }}>OUR BLOG</h1>
        </div>

        {/* Orange chat bubble */}
        <div style={{ position: 'absolute', bottom: '20px', right: '20px', zIndex: 20, width: '48px', height: '48px', borderRadius: '50%', background: '#f97316', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 16px rgba(249,115,22,0.45)' }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
        </div>
      </section>

      {/* ━━━ RECENT BLOG POSTS + FILTERS ━━━ */}
      <section style={{ background: '#07090e', padding: '56px 0 0' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 32px' }}>
          <h2 style={{ fontSize: '22px', fontWeight: 900, color: '#fff', textAlign: 'center', letterSpacing: '0.14em', marginBottom: '40px' }}>RECENT BLOG POSTS</h2>

          {/* 3 filter dropdowns */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', marginBottom: '36px' }}>
            {[
              { label: 'Falter by date:', placeholder: 'mm/dd/yy' },
              { label: 'Filter by Category:', placeholder: 'All Categories' },
              { label: 'Filter by Status:', placeholder: 'All Status' },
            ].map((f, i) => (
              <div key={i}>
                <label style={{ display: 'block', fontSize: '12px', color: 'rgba(255,255,255,0.70)', marginBottom: '6px' }}>{f.label}</label>
                <div style={{ position: 'relative' }}>
                  <select style={{ width: '100%', padding: '10px 36px 10px 14px', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.10)', borderRadius: '4px', color: 'rgba(255,255,255,0.60)', fontSize: '12px', appearance: 'none', cursor: 'pointer', outline: 'none' }}>
                    <option>{f.placeholder}</option>
                  </select>
                  <div style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="2"><polyline points="6,9 12,15 18,9"/></svg>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ━━━ BLOG GRID — exact layout from design ━━━
          Row 1: 1 large card LEFT (tall, image bg + white overlay bottom) | 2 stacked small cards RIGHT
          Row 2: 2 stacked small cards LEFT | 1 large card RIGHT (text-heavy with tags)
          Row 3: 1 wide full-width card
      */}
      <section style={{ background: '#07090e', padding: '0 0 60px' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 32px' }}>

          {/* ROW 1 */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>

            {/* Large card LEFT */}
            <div style={{ position: 'relative', borderRadius: '8px', overflow: 'hidden', minHeight: '420px', cursor: 'pointer' }}>
              <img src="https://images.unsplash.com/photo-1466692476868-aef1dfb1e735?w=700&h=500&fit=crop" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'absolute', inset: 0 }} />
              {/* Tags top-right */}
              <div style={{ position: 'absolute', top: '14px', right: '14px', display: 'flex', gap: '6px', zIndex: 2 }}>
                <Tag label="Investment" /><Tag label="Fundraising" />
              </div>
              {/* White overlay card bottom */}
              <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, background: 'rgba(255,255,255,0.92)', padding: '16px 16px 12px', borderRadius: '0 0 8px 8px', zIndex: 2 }}>
                <h3 style={{ fontSize: '15px', fontWeight: 700, color: '#111', marginBottom: '4px', lineHeight: 1.4 }}>Lorem ipsum dolor sit amet consectetur diam</h3>
                <p style={{ fontSize: '11px', color: '#888', marginBottom: '10px' }}>21-08-2024</p>
                <p style={{ fontSize: '11.5px', color: '#555', lineHeight: 1.7 }}>Lorem ipsum dolor sit amet consectetur Diam bibendum ut diam tempus sociis lectus luctus in? Lorem ipsum dolor sit amet consectetur Diam bibendum ut diam tempus sociis lectus luctus in...</p>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}><ArrowBtn /></div>
              </div>
            </div>

            {/* RIGHT column: 2 stacked small cards */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {/* Small card top */}
              <div style={{ position: 'relative', borderRadius: '8px', overflow: 'hidden', flex: 1, minHeight: '200px', cursor: 'pointer' }}>
                <img src="https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=500&h=250&fit=crop" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'absolute', inset: 0 }} />
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, transparent 30%, rgba(0,0,0,0.75) 100%)' }} />
                <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '12px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                  <div>
                    <h3 style={{ fontSize: '14px', fontWeight: 700, color: '#fff', marginBottom: '3px' }}>Lorem ipsum dolor</h3>
                    <p style={{ fontSize: '10px', color: 'rgba(255,255,255,0.60)' }}>21-08-2024</p>
                  </div>
                  <ArrowBtn />
                </div>
              </div>
              {/* Small card bottom */}
              <div style={{ position: 'relative', borderRadius: '8px', overflow: 'hidden', flex: 1, minHeight: '200px', cursor: 'pointer' }}>
                <img src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=500&h=250&fit=crop" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'absolute', inset: 0 }} />
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, transparent 30%, rgba(0,0,0,0.75) 100%)' }} />
                <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '12px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                  <div>
                    <h3 style={{ fontSize: '14px', fontWeight: 700, color: '#fff', marginBottom: '3px' }}>Lorem ipsum dolor</h3>
                    <p style={{ fontSize: '10px', color: 'rgba(255,255,255,0.60)' }}>21-08-2024</p>
                  </div>
                  <ArrowBtn />
                </div>
              </div>
            </div>
          </div>

          {/* ROW 2 */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>

            {/* LEFT column: 2 stacked small */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div style={{ position: 'relative', borderRadius: '8px', overflow: 'hidden', flex: 1, minHeight: '195px', cursor: 'pointer' }}>
                <img src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=500&h=250&fit=crop" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'absolute', inset: 0 }} />
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, transparent 25%, rgba(0,0,0,0.78) 100%)' }} />
                <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '12px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                  <div>
                    <h3 style={{ fontSize: '14px', fontWeight: 700, color: '#fff', marginBottom: '3px' }}>Lorem ipsum dolor</h3>
                    <p style={{ fontSize: '10px', color: 'rgba(255,255,255,0.60)' }}>21-08-2024</p>
                  </div>
                  <ArrowBtn />
                </div>
              </div>
              <div style={{ position: 'relative', borderRadius: '8px', overflow: 'hidden', flex: 1, minHeight: '195px', cursor: 'pointer' }}>
                <img src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=500&h=250&fit=crop" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'absolute', inset: 0 }} />
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, transparent 25%, rgba(0,0,0,0.78) 100%)' }} />
                <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '12px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                  <div>
                    <h3 style={{ fontSize: '14px', fontWeight: 700, color: '#fff', marginBottom: '3px' }}>Lorem ipsum dolor</h3>
                    <p style={{ fontSize: '10px', color: 'rgba(255,255,255,0.60)' }}>21-08-2024</p>
                  </div>
                  <ArrowBtn />
                </div>
              </div>
            </div>

            {/* RIGHT: large text card */}
            <div style={{ borderRadius: '8px', overflow: 'hidden', position: 'relative', minHeight: '402px', cursor: 'pointer' }}>
              <img src="https://images.unsplash.com/photo-1466692476868-aef1dfb1e735?w=700&h=500&fit=crop" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'absolute', inset: 0 }} />
              {/* Tags top-right */}
              <div style={{ position: 'absolute', top: '14px', right: '14px', display: 'flex', flexDirection: 'column', gap: '5px', zIndex: 2, alignItems: 'flex-end' }}>
                <Tag label="Fundraising" /><Tag label="Investment" />
              </div>
              {/* White overlay card */}
              <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, background: 'rgba(255,255,255,0.92)', padding: '16px 16px 14px', zIndex: 2 }}>
                <p style={{ fontSize: '11.5px', color: '#555', lineHeight: 1.75, marginBottom: '10px' }}>Lorem ipsum dolor sit amet consectetur Diam bibendum ut diam tempus sociis lectus luctus in? Lorem ipsum dolor sit amet consectetur Diam bibendum ut diam tempus sociis lectus luctus in...tempus sociis lectus luctus in? Lorem ipsum dolor sit amet consectetur Diam bibendum ut diam tempus sociis lectus luctus in...</p>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                  <div>
                    <h3 style={{ fontSize: '15px', fontWeight: 700, color: '#111', marginBottom: '3px', lineHeight: 1.35 }}>Lorem ipsum dolor sit amet consectetur diam</h3>
                    <p style={{ fontSize: '11px', color: '#999' }}>21-08-2024</p>
                  </div>
                  <ArrowBtn />
                </div>
              </div>
            </div>
          </div>

          {/* ROW 3 — Full width wide card */}
          <div style={{ borderRadius: '8px', overflow: 'hidden', position: 'relative', height: '280px', cursor: 'pointer', marginBottom: '40px' }}>
            <img src="https://images.unsplash.com/photo-1579621970795-87facc2f976d?w=1200&h=400&fit=crop" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, transparent 40%, rgba(0,0,0,0.55) 100%)' }} />
            {/* Tags top-right */}
            <div style={{ position: 'absolute', top: '14px', right: '14px', display: 'flex', gap: '6px', zIndex: 2 }}>
              <Tag label="Investment" /><Tag label="Fundraising" />
            </div>
            {/* Arrow bottom-right */}
            <div style={{ position: 'absolute', bottom: '16px', right: '16px', zIndex: 2 }}><ArrowBtn /></div>
          </div>

          {/* PAGINATION */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', paddingBottom: '20px' }}>
            {[1, 2, 3, 4, '...', 10].map((p, i) => (
              <button key={i} style={{
                width: p === '...' ? 'auto' : '32px', height: '32px',
                borderRadius: '4px', border: 'none', cursor: 'pointer',
                fontSize: '12px', fontWeight: 600,
                background: p === 1 ? '#f97316' : 'transparent',
                color: p === 1 ? '#fff' : 'rgba(255,255,255,0.60)',
                padding: p === '...' ? '0 4px' : '0',
              }}>{p}</button>
            ))}
          </div>
        </div>
      </section>

      <NewsletterSection />
    </>
  )
}
